export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`, `52`, `54`, `56`]
];
